import {PartnerPageShell} from "components/commons";
import {WealthyEnv} from "helpers";
import dynamic from "next/dynamic";
import React from "react";

const GoalPlanningSipLumpsumPageContent = dynamic(() => import("components/Calculators/GoalPlanningSipLumpsum"));

const GoalPlanningSipLumpsumPage = ({seoData}) => (
  <PartnerPageShell seoData={seoData}>
    <GoalPlanningSipLumpsumPageContent />
  </PartnerPageShell>
);

export async function getStaticProps() {
  const seoData = {
    title: "Goal Planning SIP + Lumpsum Calculator for MFDs | Wealthy",
    description:
      "Use Wealthy's Goal Planning SIP + Lumpsum Calculator to estimate the ideal SIP with lump sum, step-ups and inflation for smarter goal based investing.",
    keywords:
      "sip calculator, lumpsum calculator, sip return calculator, sip mutual fund calculator, sip compounding calculator, sip top up calculator, sip amount calculator, lump sum calculator, lump sum mutual fund calculator, lump sum return calculator",
    canonicalUrl: `${WealthyEnv.URL}/partner/calculators/goal-planning-sip-lumpsum`,
    ogImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-og-image.jpg`,
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: `${WealthyEnv.URL}`
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Calculators",
              item: `${WealthyEnv.URL}/partner/calculators`
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "Goal Planning SIP + Lumpsum Calculator",
              item: `${WealthyEnv.URL}/partner/calculators/goal-planning-sip-lumpsum`
            }
          ]
        },
        {
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "What is a Goal Planning SIP + Lumpsum Calculator?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "A Goal Planning SIP + Lumpsum Calculator estimates the monthly SIP required to achieve a specific financial goal after considering existing lump sum investments, expected returns, annual SIP Step-ups and inflation."
              }
            },
            {
              "@type": "Question",
              name: "How does the calculator work?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "The calculator starts with the target corpus and works backwards to estimate the monthly SIP required. It factors in investment tenure, expected annual return, Step-up percentage, existing lump sum investments and inflation to generate personalised projections."
              }
            },
            {
              "@type": "Question",
              name: "Can I include an existing lump sum investment?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Yes. The calculator estimates the future value of your existing lump sum investment and adjusts the required SIP accordingly, making the investment plan more realistic."
              }
            },
            {
              "@type": "Question",
              name: "Why should inflation be included while planning financial goals?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Inflation increases the future cost of financial goals. Factoring it into the calculation helps estimate the actual corpus required and enables more accurate long-term financial planning."
              }
            },
            {
              "@type": "Question",
              name: "Can I compare different investment scenarios?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Yes. You can modify the target corpus, investment tenure, expected returns, annual Step-up percentage, SIP amount and lump sum investment to compare multiple scenarios and identify the most suitable investment strategy."
              }
            },
            {
              "@type": "Question",
              name: "Why should Mutual Fund Distributors use this calculator?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "The calculator helps distributors simplify goal-based financial planning, improve client engagement, present visual investment projections and provide more personalised advisory services while saving valuable planning time."
              }
            }
          ]
        }
      ]
    }
  };

  return {
    props: {
      seoData
    }
  };
}

export default GoalPlanningSipLumpsumPage;
